import React from 'react'
import { count, pct, reasonLabel, reasonRows, reasonTone } from './model'

// Why the leads in this tab did not sell. A click filters the table to one
// reason, a second click on the same card clears it. The counts come from a
// response never filtered by reason, so every card stays put while one is
// selected.
export default function ReasonCards({ reasons, selected, onSelect }) {
  const rows = reasonRows(reasons)
  if (rows.length === 0) return null

  return (
    <div className="sl-reasons" role="group" aria-label="Filter by reason">
      {rows.map((r) => {
        const { label, known } = reasonLabel(r.code)
        const tone = reasonTone(r.code)
        const active = selected === r.code
        return (
          <button key={r.code} type="button" className="sl-reason" aria-pressed={active} onClick={() => onSelect(active ? null : r.code)}>
            <div style={{ display: 'flex', justifyContent: 'space-between', gap: 8, alignItems: 'baseline' }}>
              <span style={{ fontSize: 12, fontWeight: 600, color: known ? 'var(--text-primary)' : 'var(--text-muted)' }}>{label}</span>
              <span style={{ fontSize: 11, color: 'var(--text-muted)' }}>{pct(r.pct)}</span>
            </div>
            <div style={{ fontSize: 20, fontWeight: 700, marginTop: 2, fontVariantNumeric: 'tabular-nums' }}>{count(r.count)}</div>
            <div aria-hidden="true" style={{ marginTop: 6, height: 6, borderRadius: 3, background: 'var(--bg-raised)' }}>
              <div style={{ width: `${r.pct}%`, minWidth: 3, height: '100%', borderRadius: 3, background: tone.fg }} />
            </div>
          </button>
        )
      })}
    </div>
  )
}
